import { Col, Row } from 'reactstrap';
import { matchesSearch, LookupField, createLookupModel } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import CategoriaDicionarioRiscoLookup from 'src/lookups/CategoriaDicionarioRiscoLookup';

/**
 * Seção de Dicionário de Riscos
 */
const DictionarySection = ({ model, resources, intl, searchQuery }) => {
  const matchCount = matchesSearch(
    intl.formatMessage({ id: 'labelDicionarioRiscos' }, { riscos: resources.riscos }),
    searchQuery
  );

  if (!matchCount && searchQuery) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'labelDicionarioRiscos' }, { riscos: resources.riscos })}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        <Col md={12}>
          <LookupField
            Component={CategoriaDicionarioRiscoLookup}
            clearable
            multi
            highlight={matchCount}
            model={createLookupModel(
              intl.formatMessage({ id: 'labelCategoriaDicionarioRisco' }, { riscos: resources.riscos }),
              model.getModel('categoriasDicionarioRisco')?.value,
              model.getModel('categoriasDicionarioRisco')?.requestChange
            )}
          />
        </Col>
      </Row>
    </CollapsibleSection>
  );
};
export default DictionarySection;